import { Add } from '@mui/icons-material';
import { Chip, ChipProps, Tooltip } from '@mui/material';
import { t } from 'i18next';
import { Expression, FilterConfiguration } from '../types';
import { getChipLabel } from '../utils';

type Props = Pick<ChipProps<'button'>, 'onClick' | 'onDelete'> & {
  expression: Expression;
  filters: FilterConfiguration[];
};

export const ExpressionChip = ({ expression, filters, onClick, onDelete }: Props) => {
  const Component = (
    <Chip
      component="button"
      label={getChipLabel(expression, filters)}
      onClick={onClick}
      onDelete={onDelete}
      {...(onClick ? {} : { variant: 'outlined', color: 'primary', icon: <Add />, sx: { backgroundColor: 'white' } })}
    />
  );
  if (onClick) {
    return <Tooltip title={t('editExpression', { expressionLabel: getChipLabel(expression, filters, false) })}>{Component}</Tooltip>;
  }
  return Component;
};
